import React from "react";
import classNames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";
import componentsStyle from "assets/jss/material-kit-react/views/components.jsx";
import PostCard from "../Custome/PostCard";
import Grid from "@material-ui/core/Grid";
import { API } from "../config/config";
import axios from "axios";
import SearchPost from "./SearchPost";
import { Button } from "@material-ui/core";
import { Spiner } from "../Spinner/Spinner";

class AllPosts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: [],
      // infos: [],
      message_error: "",
      next: null,
      prev: null,
      order_by_direction: "ACS",
      order_by_field: "created_at",
      factory_id: "",
      state_id: "",
      area_ids: "",
      status_ids: "",
      credit_date_min: "",
      credit_date_max: "",
      states: [],
      factories: [],
      total: false,
      loading: false
    };
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const afterq = window.location.search;
    // console.log(afterq)
    let url =
      API + "/api/Posts/Post?order_by_field=created_at&order_by_direction=ACS";
    if (afterq) {
      // console.log('hastesh   ');
      url =
        API +
        "/api/Posts/Post?order_by_field=created_at&order_by_direction=ACS&" +
        afterq.substr(1);
    }
    // console.log('url');
    // console.log(afterq.substr(1));
    try {
      const getposts = {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: false,
        credentials: "same-origin",
        url: url
      };
      let responsepost = await axios(getposts);
      // console.log(responsepost)
      if (responsepost.status === 200) {
        // console.log(responsepost.data.results.data);
        this.setState({
          posts: responsepost.data.results.data,
          next: responsepost.data.results.next_page_url,
          prev: responsepost.data.results.prev_page_url,
          total: responsepost.data.results.total,
          loading: false
        });
        window.scroll({ top: 100, left: 0, behavior: "smooth" });
      } else {
        console.log("get-post-error");
        console.log(responsepost);
        alert(
          "متاسفانه مشکلی در دریافت اطلاعات بوجود آمده لطفا دوباره سعی نمایید."
        );
      }
    } catch (err) {
      console.log(err);
      this.setState({ loading: false });
      alert(
        "متاسفانه مشکلی در دریافت اطلاعات بوجود آمده لطفا دوباره سعی نمایید."
      );
    }
  }
  async searchpost(e) {
    // console.log(API + '/api/Posts/Post?order_by_field=created_at&order_by_direction=ACS&' + e)
    this.setState({ loading: true });
    try {
      const getposts = {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: false,
        credentials: "same-origin",
        url:
          API +
          "/api/Posts/Post?order_by_field=created_at&order_by_direction=ACS&" +
          e
      };
      let responsepost = await axios(getposts);
      // console.log(responsepost)
      if (responsepost.status === 200) {
        // console.log(responsepost.data.results.data);
        this.setState({
          posts: responsepost.data.results.data,
          next: responsepost.data.results.next_page_url,
          prev: responsepost.data.results.prev_page_url,
          total: responsepost.data.results.total,
          loading: false
        });
        window.scroll({ top: 100, left: 0, behavior: "smooth" });
      } else {
        console.log("get-post-error");
        console.log(responsepost);
        alert(
          "متاسفانه مشکلی در دریافت اطلاعات بوجود آمده لطفا دوباره سعی نمایید."
        );
      }
    } catch (err) {
      console.log(err);
      this.setState({
        loading: false
      });
      alert(
        "متاسفانه مشکلی در دریافت اطلاعات بوجود آمده لطفا دوباره سعی نمایید."
      );
    }
  }
  async nextPosts() {
    const { next } = this.state;
    if (next !== null) {
      this.setState({ loading: true });
      try {
        const getposts = {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          },
          withCredentials: false,
          credentials: "same-origin",
          url: next + "&order_by_field=created_at&order_by_direction=ACS"
        };
        let responsepost = await axios(getposts);
        // console.log(responsepost)
        if (responsepost.status === 200) {
          // console.log(responsepost.data.results.data);
          this.setState({
            posts: this.state.posts.concat(responsepost.data.results.data),
            next: responsepost.data.results.next_page_url,
            prev: responsepost.data.results.prev_page_url,
            total: responsepost.data.results.total,
            loading: false
          });
          // window.scroll({ top: 100, left: 0, behavior: 'smooth' });
        } else {
          console.log("get-post-error");
          console.log(responsepost);
          alert(
            "متاسفانه مشکلی در دریافت اطلاعات بوجود آمده لطفا دوباره سعی نمایید."
          );
        }
      } catch (err) {
        console.log(err);
        this.setState({ loading: false });
        alert(
          "متاسفانه مشکلی در دریافت اطلاعات بوجود آمده لطفا دوباره سعی نمایید."
        );
        // window.scroll({ top: 100, left: 0, behavior: 'smooth' });
      }
    }
  }

  render() {
    const { classes } = this.props;
    const { posts, total, next, loading } = this.state;

    return (
      <div className="AllPost pages">
        {loading && <Spiner />}
        <div
          className={classNames(classes.main, classes.mainRaised) + " page-box"}
        >
          <Grid container className={"home-main-grid"} spacing={2}>
            <SearchPost get={this.searchpost.bind(this)} />
          </Grid>
          <Grid container className={"home-main-grid"} spacing={2}>
            <Grid item sm={12} md={12}>
              {posts.length !== 0
                ? posts.map((post, i) => <PostCard post={post} key={i} />)
                : !loading && (
                    <p className="dont-post">متاسفانه پستی یافت نشد ...</p>
                  )}
            </Grid>
            <Grid item sm={12}>
              <div className="postinfos">
                {total && (
                  <p className="totalpost">
                    تعداد پست ها :<span>{total}</span>
                  </p>
                )}
                {next !== null && (
                  <Button
                    className="nex-but"
                    onClick={this.nextPosts.bind(this)}
                  >
                    پست های قدیمی تر
                  </Button>
                )}
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}
export default withStyles(componentsStyle)(AllPosts);
